<template>
  <div class="content animate-route">
    <banner bgColor="#d2d2d2" :title="title">
      <img src="@/assets/images/cleaf_banner_about.jpg" slot="image" style="width: 100%" />
      <div class="nav" slot="nav">
        <div class="list">
          <span class="title" :class="showCompany ? 'active' : ''" @click="companyShow">公司简介</span>
        </div>
        <div class="list">
          <span class="title" :class="showCleaf ? 'active' : ''" @click="cleafShow">Cleaf/可丽芙</span>
        </div>
      </div>
    </banner>
    <!-- 公司简介 -->
    <a-row class="company" v-if="showCompany">
      <a-col :span="24">
        <p>上海惟嘉经贸有限公司（SHANGHAI VIGOUR TRADING CO., LTD）成立于1998年，专业代理欧洲进口环保板材。</p>
        <p>目前，上海惟嘉代理的欧洲人造板品牌有： 奥地利爱格 EGGER 意大利可丽芙 CLEAF</p>
        <p>代理区域为：上海、江苏、浙江、安徽、福建地区。</p>
      </a-col>
      <a-col :span="24">
        <div class="pic">
          <img src="@/assets/images/about1.jpg" alt="" />
          <p>代理授权书</p>
        </div>
      </a-col>
      <a-col :span="24">
        <p>
          上海惟嘉始终坚持"以品牌为导向，以服务为核心"的经营理念，代理的品牌均为全球人造板行业的头部品牌，被国内外知名的全屋定制及家具制造商所选用，在市场上占有主导地位。
        </p>
      </a-col>
      <a-col :span="24">
        <div class="pic">
          <img src="@/assets/images/about2.jpg" alt="" />
          <p>2021年上海厨卫展</p>
        </div>
      </a-col>
      <a-col :span="24">
        <p>
          上海惟嘉拥有专业的销售团队，展厅位于上海市宜山路，同时在上海及福建地区设立仓库，可提供辐射华东地区的专业仓储、物流配套服务，竭诚欢迎您成为我们的合作伙伴！
        </p>
      </a-col>
    </a-row>
    <!-- Cleaf/可丽芙 -->
    <a-row class="cleaf" type="flex" v-if="showCleaf">
      <a-col class="text" :sm="12" :xs="24">
        <h1>品牌历史</h1>
        <p>意大利Cleaf公司成立于1970年，是一家生产高端三聚氰胺饰面材料的专业生产厂家。</p>
        <p>产品包含MFC/MDF板材，ABS封边条，防火板，CPL包覆材料等室内材料。</p>
      </a-col>
      <a-col class="text" :sm="12" :xs="24">
        <img src="@/assets/images/cleaf1.jpg" alt="" />
      </a-col>
      <a-col class="text" :sm="12" :xs="24">
        <img src="@/assets/images/cleaf2.jpg" alt="" />
      </a-col>
      <a-col class="text" :sm="12" :xs="24">
        <h1>意大利制造</h1>
        <p>
          Cleaf的目标是在材料表面上将感知触觉和审美视觉有机和谐为一体，为家具，厨卫行业持续提供高品质和创造性的饰面材料。因此，Cleaf为客户提供了一套体现品质追求及高性价比的材料解决方案。
        </p>
        <p>
          Cleaf工厂位于Brianza,
          该地区为世界一流高端家具，厨卫品牌云集的地区。Cleaf通过为这些高端家具、厨卫品牌订制材料与产品，充分展现了意大利的设计理念，工艺制造水平，及未来行业流行的发展趋势。因此某种程度上，Cleaf制造，代表了意大利制造。
        </p>
      </a-col>
      <a-col class="text" :sm="12" :xs="24">
        <h1>工艺技术</h1>
        <p>40年的订制生产经验，Cleaf已成为一家可以综合提供室内装修饰面材料及了解行业领先加工工艺的专业生产厂家。</p>
        <p>
          Cleaf的工艺技术核心体现在世界领先的板材压贴技术。公司采用世界领先的压贴生产设备，独立研发设计的钢板，高精度的裁切，封边处理，以及大型CNC加工中心，可提供室内装修领域的整体材料供应，以及材料加工后半成品的供应。
        </p>
        <p>同时Cleaf高度关注环境保护。公司产品通过全球森林环保认证。</p>
      </a-col>
      <a-col class="text" :sm="12" :xs="24">
        <img src="@/assets/images/cleaf3.jpg" alt="" />
      </a-col>
      <a-col class="text" :sm="12" :xs="24">
        <img src="@/assets/images/cleaf4.jpg" alt="" />
      </a-col>
      <a-col class="text" :sm="12" :xs="24">
        <h1>产品研发</h1>
        <p>
          Cleaf研发试验室的产品研发，不仅是材料表面的设计研发，同时充分结合了意大利建筑设计师们的原创设计理念和对新工艺技术的实践。Cleaf产品逐年荣获"红点"工业设计奖。
        </p>
        <p>
          经过技术研究和探索，将自然界，室内设计，建筑，生活时尚等不同领域的时尚元素通过高科技技术处理，真实还原再现到板材表面上。
        </p>
        <p>Cleaf板材的表面处理充分展现了设计的审美视觉和良好感知触觉。材料在运用后，体现家具产品高品质的审美诉求。</p>
      </a-col>
      <a-col class="text" :sm="12" :xs="24">
        <h1>品牌与产品获奖情况</h1>
        <p>
          Cleaf在三聚氰胺压贴饰面领域的领先被全球所认可，逐年荣获各类国际奖项。<br />
          – INTERZUM 2019红点工业智能材料和设计奖<br />
          – 2020 ADI Compasso d'Oro Award（意大利黄金罗盘奖）<br />
          – 自2009年逐年荣获：红点工业设计杰出材料奖<br />
          Mosaico 获得了"Interzum 2019
          红点工业智能材料和设计奖"。它的表面纹理是方格编织的组合，其不规则的外观由不同的深度和宽度给出。
        </p>
      </a-col>
      <a-col class="text" :sm="12" :xs="24">
        <img src="@/assets/images/cleaf5.jpg" alt="" />
      </a-col>
      <a-col class="text" :sm="12" :xs="24">
        <img src="@/assets/images/cleaf6.jpg" alt="" />
      </a-col>
      <a-col class="text" :sm="12" :xs="24">
        <h1>战略合作客户</h1>
        <p>Cleaf与意大利一线设计师及家具橱柜品牌紧密配合，相互合作与成长。</p>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import Banner from '@/components/Banner'
export default {
  name: 'About',
  components: {
    Banner,
  },
  data() {
    return {
      title: {
        eng: 'ABOUT US',
        chs: '关于我们',
      },
      showCompany: true,
      showCleaf: false,
    }
  },
  methods: {
    companyShow() {
      this.showCompany = true
      this.showCleaf = false
    },
    cleafShow() {
      this.showCompany = false
      this.showCleaf = true
    },
  },
}
</script>
<style lang="stylus" scoped>
@import './index'
route()
.content
  .nav
    menu()
    .active
      color #000
  .company, .cleaf
    max-width 1340px
    margin 0 auto
    padding 60px 0
    min-height 800px
  .company
    p
      max-width 1340px
      line-height 2
      text-align center
    .pic
      margin 27px 0
      width 100%
  .cleaf
    h1
      font-size 48px
      text-align left
    img
      width 600px
    p
      text-indent 0
      line-height 2
    .text
      padding 12px 20px
</style>
